import type { ReactElement } from 'react';

import type { RadioProps } from '../Radio';

export type RadioGroupProps = {
  children: ReactElement<RadioProps> | ReactElement<RadioProps>[];
  name: string;
  onChange: (unknown) => void;
  value: string | number;
};

export enum RADIO_GROUP_CONST {
  TEST_ID = 'radio-group',
}
